import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import MalariaTracker from './MalariaTracker';


ReactDOM.render(<MalariaTracker />, document.getElementById('root'));

